export const getters = {
  getFeatureFlagEnabling: (state) => (name, upperCase = true) => {
    if (upperCase) {
      name = name.toUpperCase();
    }
    const { listFeatureFlags } = state;
    const flag = listFeatureFlags.find(flag => flag.name === name);
    const value = flag?.value;
    if (value) {
      return value[value.type];
    } return flag?.enabled;
  },
  useSourceryPagesCreationPublication(state, getters) {
    return getters.getFeatureFlagEnabling('sourcery_pages_creation_publication');
  },
  vueAppMaintenanceMode(state, getters) {
    return getters.getFeatureFlagEnabling('vue_app_maintenance_mode');
  },
  readOnlyMode(state, getters) {
    return getters.getFeatureFlagEnabling('read_only_mode');
  },
  listFeatureFlagsLength(state) {
    return state.listFeatureFlags.length;
  },
  isEmptyFeatureFlagsList(state, getters) {
    return !getters.listFeatureFlagsLength;
  },
  useSearchWorkspaceList(state, getters) {
    return getters.getFeatureFlagEnabling('search_workspace_list_in_super_admin');
  },
  useReviseCollaboratorsToFree(state, getters) {
    return getters.getFeatureFlagEnabling('collaborators_revised_to_free');
  },
};
